import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, loading, profileCompleted } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-emerald-50" dir="rtl">
                <div className="flex flex-col items-center gap-3 text-emerald-700">
                    <Loader2 className="h-7 w-7 animate-spin" />
                    <span className="text-sm">در حال بررسی احراز هویت...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const isOnProfilePage = location.pathname === "/profile";

    if (!profileCompleted && !isOnProfilePage) {
        return <Navigate to="/profile" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
